import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { Text } from './layout';
import { Title } from '@gameonly/core';

const SectionTitleContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 120px;
  padding: 0 2.5rem 0 0;
  clip-path: polygon(0 0, calc(100% - 40px) 0, 100% 40px, 100% 100%, 0 100%);
  border-radius: 0;
  box-sizing: border-box;
  border: none;
  padding: 1rem 0;
`;

const SectionNumber = styled(Text)`
  font-size: 10rem;
  font-weight: 700;
  -webkit-text-stroke: 3px #fff;
  line-height: 1;
  font-family: Ibrand, sans-serif;
  margin-right: 1.5rem;
  margin-left: 1rem;
  min-width: 120px;
  text-align: left;
  color: transparent;
`;

const TextColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 1rem;
`;

const FirstLine = styled(Text)`
  color: #23233D;
  font-size: 2.5rem;
  font-weight: 700;
  text-transform: uppercase;
  font-family: Ibrand, sans-serif;
  letter-spacing: 0;
  line-height: 1.1;
`;

const SecondLine = styled(Text)`
  color: #fff;
  font-size: 2.5rem;
  font-weight: 700;
  text-transform: uppercase;
  font-family: Ibrand, sans-serif;
  letter-spacing: 0;
  line-height: 1.1;
`;

let globalCounter = 0;
export const SectionTitle = ({ title, style }: { title: string, style?: React.CSSProperties }) => {
  const [index, setIndex] = useState<number>(globalCounter);

  useEffect(() => {
    // Incrémentation du compteur global à chaque montage
    globalCounter += 1;
    setIndex(globalCounter);

    // Nettoyage au démontage pour éviter les fuites de mémoire
    return () => {
      globalCounter -= 1;
    };
  }, []);

  // Split title for two-line effect (customize as needed)
  const [firstLine, ...rest] = title?.split('\n') || [];
  const secondLine = rest.join(' ');

  return (
    <SectionTitleContainer style={style}>
      <SectionNumber>
        {index.toLocaleString('fr-FR', { minimumIntegerDigits: 2 })}
      </SectionNumber>
      <TextColumn>
        <FirstLine>{firstLine}</FirstLine>
        <SecondLine>{secondLine}</SecondLine>
      </TextColumn>
    </SectionTitleContainer>
  );
};
